import {useRef, useEffect} from 'react';
import {useSearchFormContext} from '../../../hooks/useSearchFormContext';
import {getDatesSummaryAndNightCountLabel, getNightsCountLabel} from '../../../utils/dates';

// eslint-disable-next-line complexity
function useComponent(props) {
    const {
        translations: {
            nightsText
        },
        mediaSettings: {
            isMobile
        },
        latestDatesValues: {
            startDate,
            endDate
        },
        systemOptions: {
            locale
        }
    } = useSearchFormContext();

    const prevStartDate = useRef(startDate);

    useEffect(() => {
        prevStartDate.current = startDate;
    }, [startDate]);

    let message = '';

    let {data} = props;

    if (isMobile) {
        message = getNightsCountLabel(startDate, endDate, nightsText);
    } else if (prevStartDate.current === startDate) {
        const endDateValue = endDate || data && data.endDate;

        message = endDateValue ?
            getDatesSummaryAndNightCountLabel(startDate, endDateValue, locale, nightsText)
            : '';
    } else {
        message = '';
        data.endDate = '';
    }

    const result = {
        message,
        isMobile
    };

    return result;
}

export {useComponent};